import React, { useState, useEffect, useRef, useCallback } from "react";
import { FaTimes, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import ReactModal from "react-modal";
import "../styles/Home.css";
import video1 from "../13/MSP.mp4";
import video2 from "../16/MSP.mp4";
import {
  FaMapMarkerAlt,
  FaCalendarAlt,
  FaClock,
  FaMicrophone,
  FaPlay,
  FaBookOpen,
  FaQuoteLeft,
  FaExpand
} from "react-icons/fa";

/* ---------- Scroll-reveal wrapper (no external libs) ---------- */
const Reveal = ({ children, className = "", delay = 0, as: Tag = "div" }) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;

    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    if (prefersReducedMotion) {
      setVisible(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.unobserve(node);
        }
      },
      { threshold: 0.15, rootMargin: "0px 0px -60px 0px" }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <Tag
      ref={ref}
      className={`reveal ${visible ? "reveal-visible" : ""} ${className}`}
      style={{ transitionDelay: visible ? `${delay}ms` : "0ms" }}
    >
      {children}
    </Tag>
  );
};

const Home = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [videoPlaying, setVideoPlaying] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(null);

  useEffect(() => {
    const checkIfMobile = () => setIsMobile(window.innerWidth <= 768);
    checkIfMobile();
    window.addEventListener("resize", checkIfMobile);
    return () => window.removeEventListener("resize", checkIfMobile);
  }, []);

  const handlePlayVideo = () => {
    setVideoPlaying(true);
    const video = document.querySelector(".hero-video");
    if (video) video.play();
  };

  const carouselImages = [
    { id: 1, src: "/carousel1/1.jpg", alt: "" },
    { id: 2, src: "/carousel1/2.jpg", alt: "" },
    { id: 3, src: "/carousel1/3.jpg", alt: "" },
    { id: 4, src: "/carousel1/4.jpg", alt: "" },
    { id: 5, src: "/carousel1/5.jpg", alt: "" },
    { id: 6, src: "/carousel1/6.jpg", alt: "" },
    { id: 7, src: "/carousel1/7.jpg", alt: "" },
    { id: 8, src: "/carousel1/8.jpg", alt: "" },
    { id: 9, src: "/carousel1/9.jpg", alt: "" },
    { id: 10, src: "/carousel1/10.jpg", alt: "" },
    { id: 11, src: "/carousel1/11.jpg", alt: "" },
    { id: 12, src: "/carousel1/12.jpg", alt: "" },
    { id: 13, src: "/carousel1/13.jpg", alt: "" }
  ];

  const openLightbox = (index) => setLightboxIndex(index);
  const closeLightbox = () => setLightboxIndex(null);

  const nextLightbox = useCallback(() => {
    setLightboxIndex((prev) =>
      prev === null ? null : (prev + 1) % carouselImages.length
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const prevLightbox = useCallback(() => {
    setLightboxIndex((prev) =>
      prev === null
        ? null
        : (prev - 1 + carouselImages.length) % carouselImages.length
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (lightboxIndex === null) return;
    const handleKey = (e) => {
      if (e.key === "ArrowRight") nextLightbox();
      if (e.key === "ArrowLeft") prevLightbox();
      if (e.key === "Escape") closeLightbox();
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [lightboxIndex, nextLightbox, prevLightbox]);

  const guests = [
    {
      date: "01.08.2025",
      day: "வெள்ளி",
      name: "ச.கந்தசாமி இ.ஆ.ப., மாவட்ட ஆட்சித் தலைவர் & மாண்புமிகு சு.முத்துசாமி",
      topic: "தொடக்க விழா"
    },
    {
      date: "02.08.2025",
      day: "சனி",
      name: "மருத்துவர் கு.சிவராமன் & மு.இராகவேந்திரன், விஜய் டிவி - தமிழ்ப்பேச்சு எங்கள் மூச்சு நிகழ்வின் வெற்றியாளர்",
      topic: "'மண்ணுயிர் நுண்ணுயிர் உன்உயிர்' 'எனைத்தானும் நல்லவை கேட்க '"
    },
    {
      date: "03.08.2025",
      day: "ஞாயிறு",
      name: "நடுவர் : கலைமாமணி திண்டுக்கல் ஐ.லியோனி",
      topic:
        "'மக்கள் சிந்தனையில் நல்ல மாற்றத்தைப் பெரிதும் தருவது பேச்சா? எழுத்தா? பாட்டா ? திரையா?'"
    },
    {
      date: "04.08.2025",
      day: "திங்கள்",
      name: "சுகி.சிவம் & கே.வைத்தியநாதன் ஆசிரியர் தினமணி நாளிதழ்",
      topic: "'ஊருக்கு நல்லது சொல்வேன்' 'வையத்து வாழ்வாங்கு வாழ்பவர்'"
    },
    {
      date: "05.08.2025",
      day: "செவ்வாய்",
      name: "டாக்டர் ஜி.விஸ்வநாதன் வேந்தர், விஐடி பல்கலைக்கழகம் & வி.டில்லிபாபு இராணுவ விஞ்ஞானி, இந்தியப் பாதுகாப்புத்துறை",
      topic: "'அறிவியல் மேதை ஜி.டி. நாயுடு விருது' வழங்கும் நிகழ்வு கருத்துரை"
    },
    {
      date: "06.08.2025",
      day: "புதன்",
      name: "பேராசிரியர் சொ.சொ.மீ. சுந்தரம் கவிதா ஜவகர்",
      topic: "'நெய்த நூலும் நெய்யாத நூலும் ' இலக்கியத்தில் உயிர் நேயம்'"
    },
    {
      date: "07.08.2025",
      day: "வியாழன்",
      name: "புலவர் செந்தலை ந.கவுதமன் & பாவலர் அறிவுமதி",
      topic: "'புதுக்கருத்தும் பொதுக்கருத்தும்' தமிழருக்கில்லை - தமிழ்'"
    },
    {
      date: "08.08.2025",
      day: "வெள்ளி",
      name: "கவிஞர் ஜோ மல்லூரி விஷ்ணுபுரம் சரவணன் பால சாகித்ய புரஸ்கார் -2025 விருதாளர்",
      topic: "'அறிவை விரிவு செய்..''குழந்தைகளோடு கதையாடு...'"
    },
    {
      date: "09.08.2025",
      day: "சனி",
      name: "கோமல் தியேட்டர் வழங்கும்சிறுகதைகள் மேடையில்...(பிரபல எழுத்தாளர்களின் சிறுகதைகள் நாடகமாக அரங்கேறுகின்றன)",
      topic: "படைப்பாளிகளைப் போற்றுவோம்"
    },
    {
      date: "10.08.2025",
      day: "ஞாயிறு",
      name: "கி.அமர்நாத் ராமகிருஷ்ணா இயக்குநர், இந்திய தொல்லியல் ஆய்வுத்துறை - புதுடில்லி & ரா.விஜயன் மூத்த ஆசிரியர், புதிய தலைமுறை தொலைக்காட்சி",
      topic: "புத்தகம் எனும் பெரும் மரம்"
    },
    {
      date: "11.08.2025",
      day: "திங்கள்",
      name: "கலைமாமணி டி.கே.எஸ்.கலைவாணன் & அரு.நாகப்பன்",
      topic: "வாசிப்பின் வழிகாட்டி"
    },
    {
      date: "12.08.2025",
      day: "செவ்வாய்",
      name: "முனைவர் இறையன்பு ஐஏஎஸ் (ஓய்வு) மேனாள் தலைமைச் செயலாளர், தமிழ்நாடு அரசு",
      topic: "நிறைவு விழா"
    }
  ];

  const slogans = [
    { number: "01", text: "இல்லந்தோறும் நூலகம்" },
    { number: "02", text: "நூலகமில்லா ஊரில் குடியிருக்க வேண்டாம்" },
    { number: "03", text: "நல்ல நூல்களே நல்ல நண்பர்கள்" }
  ];

  const objectives = [
    "வெறும் நூல் வணிகத்தை மட்டுமே அடிப்படையாகக் கொண்டு இப்புத்தகத் திருவிழா நடத்தப்படவில்லை. மாறாக... நல்ல நூல்களை நாட்டு மக்களுக்கு அறிமுகப்படுத்தும் உயர்ந்த நோக்கிலும், அவ்வாறு கிடைக்கப்பெறும் சிறந்த நூல்களை வாசிக்கத் தூண்டும் எண்ணத்திலும் இப்புத்தகத் திருவிழா நடத்தப்படுகிறது.",
    "சடங்கு பூர்வமாகவோ, சம்பரதாயத்திற்காகவோ நடத்தப்படாமல் முழுக்க முழுக்க சமுதாய நோக்கிலேயே இப்புத்தகத் திருவிழா நடத்தப்படுகிறது.",
    "தமிழர்களுக்கு விசாலமான உலகப்பார்வையை உருவாக்கும் பொருட்டு உலகு தழுவிய இலக்கியங்கள், அரசியல் கருத்துகள், விஞ்ஞானக் கண்டுபிடிப்புகள், வரலாற்றுச் செய்திகள், தொழில்நுட்ப விளக்கங்கள், வணிக அனுபவங்கள், தொழில் வளர்ச்சி ஆலோசனைகள், வேளாண்மை முயற்சிகள் போன்ற பன்முகத் தலைப்புக்களிலான மிகத் தரமான நூல்களை மக்கள் கரங்களில் தவழச் செய்வது.",
    "பட்டப்படிப்பு, பல்வேறு துறைசார்ந்த உயர்பட்டப் படிப்பு மற்றும் ஆராய்ச்சிப் படிப்பிற்குத் தேவையான, தேடினாலும் கிடைக்கப்பெறாத நூல்களை பல்வேறு தரமான வெளியீட்டாளர்களின் மூலம் இப்புத்தகத் திருவிழாவில் மாணவர்களுக்கு கிடைக்க ஏற்பாடு செய்வது.",
    "பள்ளி, கல்லூரிகளில் பயிலும் மாணவர்களுக்குப் பாடப் புத்தகங்கள் போக வேறு பொதுவான பயனுள்ள நூல்களை வாசிக்கும் பழக்கத்தை மேம்படுத்துவது. மதிப்பெண்கள் பெறுவது மட்டுமல்லாமல் மனித மதிப்புகளைக் கற்றுக் கொடுக்கும் நூல்களை வாசிக்கும் வழக்கத்தை மாணவர்கள் மத்தியில் அதிகரிப்பது.",
    "நம் நாடு பற்றிய கடந்த காலப் பெருமிதத்தையும், நிகழ்கால நிகழ்வுகள் குறித்த கவலையையும், எதிர்காலம் பற்றிய கனவுகளையும் இளைஞர்களின் நெஞ்சங்களில் உருவாக்குவது. எதிர்கால இந்தியா எப்படி இருக்க வேண்டும் என்பது குறித்த ஆழ்ந்த சிந்தனையை உருவாக்குவதோடு, அவ்வாறு கனவில் முகிழ்க்கும் மகிழ்ச்சி நிறைந்த இந்தியாவை நனவில் படைக்க இளைஞர்களையும், மாணவர்களையும் கடுமையாக உழைக்கும் பொருட்டு களமிறக்குவது.",
    "கொங்கு மண்டலத்திலுள்ள கல்வி நிலையங்களின் நூலகங்களுக்கு உரிய கழிவுகளுடன் நல்ல நூல்கள் கிடைக்க ஏற்பாடு செய்வது. பொது நூலகங்களில் நல்லுள்ளம் கொண்டவர்களின் உதவிகள் மூலம் ஏராளமான நல்ல நூல்கள் இடம்பெற முயற்சிகள் மேற்கொள்வது.",
    "படித்தவர்கள், பட்டம் பெற்றவர்கள், படைப்பாளிகள், மாணவர்கள், ஆசிரியர்கள் என்பதோடு மட்டுமல்லாமல் அவ்வளவாகக் கல்வியறிவில்லாத பாட்டாளி மக்களும் சாதாரண நிலையிலிருக்கும் சாமானியர்களும் கூட இப்புத்தகத் திருவிழாவை நன்கு பயன்படுத்தி, அவர்களும் நிறைய நூல்கள் வாசித்து உலக அறிவு பெற்றவர்களாக உயர இப்புத்தகத்திருவிழா மூலம் முயற்சிப்பது.",
    "புத்தகத் திருவிழாவில் தினம்தோறும் மாலைப்பொழுதில் நடைபெறும் இலக்கியக் கூட்டங்களில் பல்லாயிரம் பேரைப் பங்கேற்க வைத்து, அறிஞர்கள் கூறும் கருத்துக்களைக் கேட்பதன் மூலம் அவர்களுக்கு நூல்கள் குறித்த ஈடுபாட்டை ஏற்படுத்த முயற்சிப்பது."
  ];

  return (
    <div className="home-container">
      <div className={`main-content ${!isMobile ? "with-sidebar" : ""}`}>

        {/* ============ HERO — split screen ============ */}
        <div className="hero-section">
          <div className="hero-grid">
            <div className="hero-left">
              <div className="hero-grain"></div>
              <div className="hero-glow"></div>
              <Reveal as="div" className="hero-left-inner">
                <span className="hero-badge">
                  <FaBookOpen /> 22ஆம் ஆண்டு &nbsp;•&nbsp; 2026
                </span>
                <h1 className="hero-title">
                  ஈரோடு
                  <span className="hero-title2">புத்தகத் திருவிழா</span>
                </h1>
                <p className="hero-description">
                  2005 ஆம் ஆண்டு முதல் மக்கள் சிந்தனைப் பேரவையால் நடத்தப்படும்
                  ஈரோடு புத்தகத் திருவிழா ஒவ்வொரு ஆண்டும் மிகச் சிறப்பாக
                  நடைபெற்று வருகிறது.
                </p>
                <div className="hero-cta-row">
                  <a href="#guests" className="hero-cta primary">
                    விருந்தினர்களைக் காண
                  </a>
                  <a href="#gallery" className="hero-cta ghost">
                    நினைவுகள்
                  </a>
                </div>
              </Reveal>
            </div>

            <div className="hero-right">
              <div className="hero-video-frame">
                {!videoPlaying && (
                  <button
                    className="play-button-overlay"
                    onClick={handlePlayVideo}
                    aria-label="Play video"
                  >
                    <span className="play-button-icon">
                      <FaPlay />
                    </span>
                  </button>
                )}
                <video
                  controls
                  className="hero-video"
                  autoPlay={videoPlaying}
                  muted={!videoPlaying}
                  playsInline
                >
                  <source src={video1} type="video/mp4" />
                </video>
              </div>
            </div>
          </div>

          {/* Floating info bar straddling the split */}
          <Reveal as="div" className="hero-infobar" delay={150}>
            <div className="infobar-item">
              <FaMapMarkerAlt className="infobar-icon" />
              <span>சிக்கய்ய அரசு கலை &amp; அறிவியல் கல்லூரி மைதானம், ஈரோடு</span>
            </div>
            <div className="infobar-divider" />
            <div className="infobar-item">
              <FaCalendarAlt className="infobar-icon" />
              <span>ஆகஸ்ட் 1 – 12</span>
            </div>
            <div className="infobar-divider" />
            <div className="infobar-item">
              <FaClock className="infobar-icon" />
              <span>காலை 11 – இரவு 9:30</span>
            </div>
            <div className="infobar-divider" />
            <div className="infobar-item">
              <FaMicrophone className="infobar-icon" />
              <span>தினமும் மாலை 6 மணிக்கு சொற்பொழிவு</span>
            </div>
          </Reveal>
        </div>

        {/* ============ SLOGANS — connected chain ============ */}
        <section className="slogans-section">
          <Reveal as="h3" className="slogans-heading">
            'மக்கள் சிந்தனைப் பேரவை' முன்வைக்கும் முப்பெரும் முழக்கங்கள்
          </Reveal>
          <div className="slogans-chain">
            {slogans.map((slogan, i) => (
              <Reveal
                key={slogan.number}
                delay={i * 150}
                className="slogan-node"
                as="div"
              >
                <div className="slogan-number">{slogan.number}</div>
                <div className="slogan-text">{slogan.text}</div>
              </Reveal>
            ))}
          </div>
        </section>

        {/* ============ OBJECTIVES — zig-zag magazine rows ============ */}
        <section className="objectives-section">
          <Reveal as="div" className="objectives-header-wrap">
            <span className="section-eyebrow">நோக்கம்</span>
            <h2 className="objectives-heading">
              புத்தகத் திருவிழாவின் நோக்கங்கள்
            </h2>
          </Reveal>

          <div className="objectives-rows">
            {objectives.map((text, index) => (
              <Reveal
                key={index}
                className={`objective-row ${
                  index % 2 === 1 ? "objective-row-reverse" : ""
                }`}
                as="div"
              >
                <div className="objective-ghost-num">
                  {String(index + 1).padStart(2, "0")}
                </div>
                <p className="objective-text">{text}</p>
              </Reveal>
            ))}
          </div>
        </section>

        {/* ============ GUESTS — vertical timeline ============ */}
        <section className="timeline-section" id="guests">
          <Reveal as="div" className="timeline-header">
            <span className="section-eyebrow">விருந்தினர்கள்</span>
            <h2 className="section-title">
              புத்தகத் திருவிழா 2026 - சிறப்பு விருந்தினர்
            </h2>
          </Reveal>

          <div className="timeline">
            <div className="timeline-spine" />
            {guests.map((guest, index) => (
              <Reveal
                key={index}
                delay={(index % 4) * 80}
                as="div"
                className={`timeline-item ${
                  index % 2 === 0 ? "timeline-left" : "timeline-right"
                }`}
              >
                <div className="timeline-dot">{index + 1}</div>
                <div className="timeline-card">
                  <div className="timeline-date">
                    {guest.date} <em>({guest.day})</em>
                  </div>
                  <div className="timeline-name">{guest.name}</div>
                  <div className="timeline-topic">{guest.topic}</div>
                </div>
              </Reveal>
            ))}
          </div>
        </section>

        {/* ============ GALLERY — bento grid + lightbox ============ */}
        <section className="gallery-section" id="gallery">
          <Reveal as="div" className="timeline-header">
            <span className="section-eyebrow">நினைவுகள்</span>
            <h2 className="section-title">புத்தகத் திருவிழா நினைவுகள்</h2>
          </Reveal>

          <div className="bento-grid">
            {carouselImages.map((image, index) => (
              <Reveal
                key={image.id}
                delay={(index % 6) * 60}
                as="button"
                className={`bento-tile ${
                  index === 0 ? "bento-tile-featured" : ""
                }`}
              >
                <span
                  className="bento-tile-inner"
                  onClick={() => openLightbox(index)}
                  role="button"
                  tabIndex={0}
                >
                  <img
                    src={image.src}
                    alt={image.alt}
                    loading="lazy"
                    className="bento-img"
                  />
                  <span className="bento-overlay">
                    <FaExpand />
                  </span>
                </span>
              </Reveal>
            ))}
          </div>
        </section>

        {/* ============ CLOSING — video + quote split ============ */}
        <section className="closing-section">
          <Reveal as="div" className="closing-video-wrap">
            <video controls className="closing-video" muted playsInline>
              <source src={video2} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </Reveal>

          <Reveal as="div" className="closing-quote-wrap" delay={150}>
            <FaQuoteLeft className="closing-quote-icon" />
            <p className="closing-quote-text">
              With the lyrics of Vairamuthu sir about our book festival, the
              miracle of the book and the reader unite the moment a reader
              enters a book.
            </p>
            <span className="closing-quote-sub">
              22nd Annual Erode Book Festival 2026 — conducted by Tamil Nadu
              Government &amp; People's Thought Council, Erode
            </span>
          </Reveal>
        </section>

        {/* ============ LIGHTBOX MODAL ============ */}
        <ReactModal
          isOpen={lightboxIndex !== null}
          onRequestClose={closeLightbox}
          className="image-modalhm"
          overlayClassName="image-modal-overlayhm"
          ariaHideApp={false}
        >
          <button className="modal-closehm" onClick={closeLightbox} aria-label="Close">
            <FaTimes />
          </button>
          {lightboxIndex !== null && (
            <>
              <button
                className="modal-navhm modal-prevhm"
                onClick={prevLightbox}
                aria-label="Previous image"
              >
                <FaChevronLeft />
              </button>
              <img
                src={carouselImages[lightboxIndex].src}
                alt="Full screen"
                className="modal-imagehm"
              />
              <button
                className="modal-navhm modal-nexthm"
                onClick={nextLightbox}
                aria-label="Next image"
              >
                <FaChevronRight />
              </button>
              <div className="modal-counterhm">
                {lightboxIndex + 1} / {carouselImages.length}
              </div>
            </>
          )}
        </ReactModal>
      </div>
    </div>
  );
};

export default Home;